module.exports = __webpack_public_path__ + "img/logo.5f0db2e9.png";